import {useAlert} from "@contexts/hooks/useAlert.ts";
import {CreateContaContabil} from "@components/contaContabil/endpoints/__contacontabil_endpoints.js";
import type {IContaContabil} from "@models/contaContabil/contaContabil.js";
import type {ICreateContaContabilDto} from "@models/contaContabil/createContaContabilDto.js";
import {Save} from "@mui/icons-material";
import {Button, TextField} from "@mui/material";
import {DefaultContainer} from "@shared/DefaultContainer.js";
import {ToInt} from "@shared/MathHelp.js";
import React, {useEffect, useState} from "react";
import {DefaultEventProps, DefaultPageProps} from "@models/DefaultProps.ts";
import {ContaContabilPesquisa} from "@components/contaContabil/ContaContabilPesquisa.tsx";

interface ContaContabilCadastraPageProps extends DefaultPageProps, Pick<DefaultEventProps<IContaContabil>, 'onCreate'> {
}


export function ContaContabilCadastraPage(props: ContaContabilCadastraPageProps) {
    const {createAlertFromResponse} = useAlert()
    const {onCreate} = props
    const [contaPai, setContaPai] = useState<IContaContabil | undefined>(undefined)
    const [dados, setDados] = useState<ICreateContaContabilDto>({
        nome: ''
    })

    useEffect(() => {
        setDados({...dados, contaContabilPaiId: contaPai?.id ?? undefined})
    }, [contaPai])

    const handleSave = () => {
        CreateContaContabil(dados).then((x) => {
            createAlertFromResponse(x)
            if (x.status == 'Success') {
                if (onCreate) onCreate(x.items)
            }
        })
    }

    const changeCodigoReduzido = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = ToInt(e.target.value)

        if (value == 0) {
            setDados({
                nome: dados.nome,
                contaContabilPaiId: contaPai?.id ?? undefined,
                idNivel: dados.idNivel,
            });
        }

        setDados({...dados, codigoReduzido: value});
    }

    const changeNumeroConta = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = ToInt(e.target.value)

        if (value == 0) {
            setDados({
                nome: dados.nome,
                contaContabilPaiId: contaPai?.id ?? undefined,
                codigoReduzido: dados.codigoReduzido,
            });
        }

        setDados({...dados, idNivel: value});
    }

    return <DefaultContainer titulo={'Cadastrar Conta Contábil'}
                             hideHeader={props.hideHeader}
                             size={'large'}>

        <TextField label={'Nome'}
                   value={dados.nome}
                   fullWidth
                   onChange={(e) => setDados({...dados, nome: e.target.value})}>
        </TextField>
        <TextField label={'Código reduzido'}
                   value={dados.codigoReduzido ?? ''}
                   fullWidth
                   onChange={changeCodigoReduzido}/>
        <TextField type={'number'} value={dados.idNivel ?? ''} fullWidth
                   onChange={changeNumeroConta}
                   label={'Numero da conta'}/>
        <ContaContabilPesquisa onItemSelected={(conta) => {
            setContaPai(conta)
        }} display={{label: 'Conta contábil base'}}
        />
        <Button variant={"outlined"}
                onClick={handleSave}
                color={'success'}
                fullWidth
                endIcon={<Save/>}
        >Salvar</Button>

    </DefaultContainer>
}

